/**
 * Pick of the Week Component
 */

import { useState, useEffect } from '@wordpress/element';
import { useFilms } from '../context/FilmContext';
import AlertButton from './AlertButton';
import dayjs from 'dayjs';

export default function PickOfWeek() {
    const { fetchPickOfWeek, loading } = useFilms();
    const [data, setData] = useState(null);

    const t = window.rialtoData?.translations || {};

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const result = await fetchPickOfWeek();
        setData(result);
    };

    if (loading && !data) {
        return (
            <div className="rialto-loading">
                <div className="rialto-spinner"></div>
            </div>
        );
    }

    if (!data?.pick) {
        return null;
    }

    const { pick } = data;
    const film = pick.film;
    const nextScreening = pick.next_screening;

    return (
        <div className="rialto-pick rialto-pick-of-week">
            {film.poster && (
                <div className="rialto-pick-bg">
                    <img src={film.poster} alt="" />
                </div>
            )}

            <div className="rialto-pick-content">
                <div className="rialto-pick-poster">
                    <img src={film.poster || film.poster_thumb} alt={film.title} />
                </div>

                <div className="rialto-pick-info">
                    <span className="rialto-pick-label">
                        {t.pickOfWeek || 'Pick of the Week'}
                    </span>

                    <h2 className="rialto-pick-title">{film.title}</h2>

                    <div className="rialto-pick-meta">
                        {film.year && <span>{film.year}</span>}
                        {film.genres?.length > 0 && <span> | {film.genres.join(', ')}</span>}
                        {film.duration && <span> | {film.duration} {t.minutes || 'min'}</span>}
                        {film.certification && (
                            <span className="rialto-cert">{film.certification}</span>
                        )}
                    </div>

                    {(film.director || film.actors) && (
                        <div className="rialto-pick-credits">
                            {film.director && (
                                <p><strong>{t.director || 'Director'}:</strong> {film.director}</p>
                            )}
                            {film.actors && (
                                <p><strong>{t.starring || 'Starring'}:</strong> {film.actors}</p>
                            )}
                        </div>
                    )}

                    {film.synopsis && (
                        <p className="rialto-pick-synopsis">{film.synopsis}</p>
                    )}

                    {nextScreening && (
                        <div className="rialto-pick-time">
                            Next screening: {dayjs(nextScreening.datetime).format('dddd D MMMM')} at {nextScreening.time}
                        </div>
                    )}

                    <div className="rialto-pick-actions">
                        {nextScreening && (
                            <AlertButton
                                screeningId={nextScreening.id}
                                filmTitle={film.title}
                                screeningTime={nextScreening.datetime}
                            />
                        )}

                        {film.youtube_trailer && (
                            <a
                                href={film.youtube_trailer}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="rialto-btn rialto-btn-secondary"
                            >
                                {t.watchTrailer || 'Watch Trailer'}
                            </a>
                        )}

                        <a href={film.url} className="rialto-btn rialto-btn-secondary">
                            {t.moreInfo || 'More Info'}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
